namespace Ir.Components.Workbook.ToolBar.EmailLogsToolBar {
    interface IEmailLogsToolBarViewModel {
        buttonOptions: any,
    }

    export function getViewModel(this: IEmailLogsToolBarViewModel, params: any) {
        this.buttonOptions = {
            hint: 'Email Logs',
            template: `<i class="ms">contact_mail</i> <span>Email Logs</span>`,
            visible: ko.computed(function () {
                return loggedUser.permissions.emailsManagement();
            }),
            onClick(e) {
                Ir.Components.Email.EmailLog.show();
            }
        }
    }
}